import { Button } from 'reactstrap';
import FormModal from '../../components/modals/FormModal';
import ContractForm from './components/ContractForm';
import { UpdateContractForm } from './models/contractModel';
import useModalState from '../../hooks/useModalState';
import useContract from './hooks/useContract';

interface Props {
  contract_id: string;
  price: number;
  has_rental_managment: boolean;
}

const UpdateContractModal = ({
  contract_id,
  price,
  has_rental_managment,
}: Props) => {
  const { apiErrors, doUpdateContract } = useContract();
  const [isOpenModal, toggleModal] = useModalState();

  const handleUpdate = async (form: UpdateContractForm) => {
    try {
      doUpdateContract(contract_id, form);
    } catch (e) {}
  };

  const form = (
    <ContractForm
      contract={{
        price: price,
        has_rental_management: has_rental_managment,
      }}
      handleUpdate={handleUpdate}
    />
  );

  return (
    <>
      <Button
        color="info"
        onClick={() => {
          //modal here
          toggleModal();
        }}
      >
        Actualizar información del contrato
      </Button>
      <FormModal
        children={form}
        headerText="Actualizar información de contracto"
        isOpen={isOpenModal}
        onConfirmation={() => {}}
        onReset={() => {}}
        onToggle={toggleModal}
        size="sm"
        withFooterActions={false}
      />
    </>
  );
};

export default UpdateContractModal;
